module.exports = __webpack_public_path__ + "0f50f4f6cd85a099f71a814eb31fe2a5.png";